function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "bus");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard-Copy-3",
  transform: "translate(-207.000000, -134.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M207,145.789474 C207,146.530526 207.328421,147.195789 207.842105,147.658947 L207.842105,149.157895 C207.842105,149.621053 208.221053,150 208.684211,150 L209.526316,150 C209.989474,150 210.368421,149.621053 210.368421,149.157895 L210.368421,148.315789 L217.105263,148.315789 L217.105263,149.157895 C217.105263,149.621053 217.484211,150 217.947368,150 L218.789474,150 C219.252632,150 219.631579,149.621053 219.631579,149.157895 L219.631579,147.658947 C220.145263,147.195789 220.473684,146.530526 220.473684,145.789474 L220.473684,137.368421 C220.473684,134.421053 217.458947,134 213.736842,134 C210.014737,134 207,134.421053 207,137.368421 L207,145.789474 Z M209.947368,146.631579 C209.248421,146.631579 208.684211,146.067368 208.684211,145.368421 C208.684211,144.669474 209.248421,144.105263 209.947368,144.105263 C210.646316,144.105263 211.210526,144.669474 211.210526,145.368421 C211.210526,146.067368 210.646316,146.631579 209.947368,146.631579 Z M217.526316,146.631579 C216.827368,146.631579 216.263158,146.067368 216.263158,145.368421 C216.263158,144.669474 216.827368,144.105263 217.526316,144.105263 C218.225263,144.105263 218.789474,144.669474 218.789474,145.368421 C218.789474,146.067368 218.225263,146.631579 217.526316,146.631579 Z M218.789474,141.578947 L208.684211,141.578947 L208.684211,137.368421 L218.789474,137.368421 L218.789474,141.578947 Z",
  id: "bus"
})));

var SvgBus = function SvgBus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bus.e5ad0b6e.svg";
export { ForwardRef as ReactComponent };